const baseRoute = '/ap-service-settings'

const createSubRoute = (subRoute: string) => ({
  route: `${baseRoute}/:serviceAreaId${subRoute}`,
  path: `/:serviceAreaId${subRoute}`,
})

export const ApServiceSettingsAreaRoutes = {
  route: baseRoute,
  path: '/',
  Configuration: createSubRoute('/configuration'),
  StopConfiguration: createSubRoute('/stop-configuration'),
  ServiceHours: createSubRoute('/service-hours'),
}
